
export const CrestMembershipNumber = /^[0-9]{7}[A-Za-z]{1}$/;


export function isValidSortCode(value) {
    const numberFormatRegex = /^[0-9]{6}$/;
    return numberFormatRegex.test(value);
  }

  
export function isValidAccountNo(value) {
  const numberFormatRegex = /^[0-9]{8}$/;
  return numberFormatRegex.test(value);
}


export function isValidAccountName(value) {
// const numberFormatRegex = /^[A-Za-z-'\s]{1,34}$/;
 const numberFormatRegex = /^[A-Za-z][A-Za-z\s'-]{1,34}$/;
  return numberFormatRegex.test(value);
}

export function isSpecialCharacters(value) {

  const numberFormatRegex = /^[0-9]$/;
  // const alphanumeric = /^[A-Za-z0-9]$/;
  // const specialCharacterRegex = /^[A-Za-z]$/;
  // const spaceRegex=/^[\s]$/;
  
  return numberFormatRegex.test(value);
  //|| alphanumeric.test(value) || !specialCharacterRegex.test(value) || spaceRegex.test(value);
}